import * as yup from 'yup';

const { object, string, array, boolean } = yup;

export type LocationFormData = yup.InferType<typeof locationSchema>;

export const locationSchema = object({
  name: string().required('error.form.required'),
  atkomstClientId: string().required('error.form.required'),
  primaryCdsLocation: string().required('error.form.required'),
  cdsLocation: array().of(string().required()).default([]),
  country: string().required('error.form.required'),
  enabled: boolean().required().default(true),
  mainLanguage: string().required('error.form.required'),
});
